import React, {Component} from 'react';
import {roundigFormat} from '../libs/utils/Operations';
import moment from 'moment';
import '../css/dataTables.css';


const renderTableBody = (headers, data, action, checkbox,DisabledItems) => {
    let body= "";
    body = data.map((register, index) => {
        return (
            <tr key={index}>
                <td style={{textAlign:"center", width:100}}>
                    <input type="checkbox" style={{minWidth: '100%'}} id="cbox2" checked={!!checkbox.data.get(index)} disabled={ register.selected || false}
                           onChange={() => checkbox.selectOne(index)}/>
                </td>
                <td>{register.Code || ""}</td>
                <td className="overflow-visible"style={{textAlign: 'left', maxWidth: 800}}>
                    {register.ItemName || ""}
                </td>
                
            </tr>
        )
    })
    return body;
};

const renderTable = (headers, data, action, checkbox,DisabledItems) => {
    let header = "";
    let body = "";
    
    if (headers.length != 0) {
        header = <tr>
            <td className="sticky-header table-header-yellow ">
                <input type="checkbox" style={{minWidth: '100%'}}
                       onChange={(event) => checkbox.selectAll(event.target.checked)}/>
            </td>
            <td className="sticky-header table-header-yellow ">{headers[0].title}</td>
            <td className="sticky-header table-header-yellow ">{headers[1].title}</td>
        </tr>;
    }

    body = renderTableBody(headers, data, action, checkbox,DisabledItems);

    let table = "";

    table =
    //
        <div className="table-wrapper-scroll-y my-custom-scrollbar"> 
            <table id="dataTableCreate" className="display" style={{width: '100%'}}>
                <thead className="table-header">
                {header}
                </thead>
                <tbody>
                {body}
                </tbody>
            </table>
        </div>;

    return table;

};

export const renderTableListMaterialModal = (headers, data, action,checkbox,DisabledItems) => {
  
    return renderTable(headers, data, action, checkbox,DisabledItems);

}
